import { render } from "./lunbo.vue?vue&type=template&id=2e94285e&scoped=true"
import script from "./lunbo.vue?vue&type=script&lang=js"
export * from "./lunbo.vue?vue&type=script&lang=js"

import "./lunbo.vue?vue&type=style&index=0&id=2e94285e&scoped=true&lang=less"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e94285e"]])

export default __exports__